import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PrimaryButton from '../common/PrimaryButton';
import Link from '@mui/material/Link';
import { Script } from 'gatsby';

function MasterListNewTitleSection() {
    const theme = useTheme();
    const isMdSmScreen = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <Container
            maxWidth="xxl"
            sx={{
                paddingTop: '10rem',
            }}
        >
            <Script src="https://app.simplegoods.co/assets/external/embed.js" />

            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                sx={{
                    minHeight: 800,
                    marginLeft: 0,
                    width: '100%',
                }}
            >
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={9}
                    sx={{
                        [theme.breakpoints.up('xl')]: {
                            paddingLeft: '5% !important',
                            paddingRight: '5%',
                        },
                        [theme.breakpoints.down('lg')]: {
                            paddingLeft: '10% !important',
                            paddingRight: '10% !important',
                        },
                        [theme.breakpoints.up('lg')]: {
                            paddingLeft: '5rem !important',
                            paddingRight: '4rem',
                        },
                    }}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            flexGrow: 1,
                            fontWeight: 600,
                            fontSize: '3rem',
                            lineHeight: '3.75rem',
                            [theme.breakpoints.down(480)]: {
                                fontSize: '3rem',
                            },
                        }}
                    >
                        U.S. COLLEGE CAREER FAIRS LIST
                    </Typography>
                    <Typography
                        variant="h2"
                        sx={{
                            flexGrow: 1,
                            paddingBottom: '40px',
                            fontWeight: 600,
                            fontSize: '32px',
                            lineHeight: '40px',
                            [theme.breakpoints.down(480)]: {
                                fontSize: '3rem',
                            },
                        }}
                    >
                        FALL 2023 - SPRING 2024
                    </Typography>
                    <Grid
                        item
                        xl={9}
                    >
                        <Typography
                            variant="body1"
                            display="inline"
                            sx={{
                                fontWeight: 600,
                                fontSize: '24px',
                            }}
                        >
                            THE NEWEST EDITION </Typography>
                        <Typography
                            variant="body1"
                            display="inline"
                            sx={{
                                fontSize: '24px',
                            }}
                        >
                            - Grab the comprehensive list of 1000+ U.S. career fairs, and virtual events included in Fall 2023 - Spring 2024 with details on registration deadlines, event times, and locations!
                        </Typography>
                    </Grid>
                    <Typography
                        variant="body1"
                        sx={{
                            paddingTop: '20px',
                            paddingBottom: '44px',
                        }}
                    >
                        Get your list today and get these amazing bonuses:
                        <ul style={{ margin: 0, paddingLeft: '25px' }}>
                            <li>A free updated version of the master list at the beginning of each semester.</li>
                            <li>Unlimited access to our free Recruiter Resources.</li>
                            <li>List of 50+ Student & Professional Diversity Organizations.</li>
                        </ul>
                    </Typography>

                    <Grid
                        item
                        container
                        sx={{
                            paddingBottom: '15rem',
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            xl={8}
                            sx={{
                                textAlign: 'center',
                            }}
                        >
                            <Link
                                href="https://app.simplegoods.co/i/NCXFMJTI"
                                sx={{
                                    textDecoration: 'none',
                                }}
                            >
                                <PrimaryButton
                                    type="submit"
                                    variant="container"
                                    sx={{
                                        paddingLeft: '50px',
                                        paddingRight: '50px',
                                        [theme.breakpoints.down('lg')]: {
                                            width: '100%',
                                        },
                                    }}
                                >
                                    Buy Now
                                </PrimaryButton>
                            </Link>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            xl={8}
                        >
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    paddingTop: '5px',
                                    textAlign: 'center',
                                }}
                            >
                                <Link href="/document/(SAMPLE)-Master-List-of-US-Career-fairs-Fall-2023-Spring-2024.xlsx" underline="hover" download>
                                    Download a Free Sample
                                </Link>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container >
    );
}

export default MasterListNewTitleSection;
